
// function for dynamic sorting of JavaScript Object Arrays...

export const compareValues = (key, order = 'asc') => {
  return function (a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    const varA = (typeof a[key] === 'string') ?
      a[key].toUpperCase() : a[key];
    const varB = (typeof b[key] === 'string') ?
      b[key].toUpperCase() : b[key];

    let comparison = 0;

    if (key === 'hits') {
      comparison = varA - varB;
    }
    else {
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
    }
    return (
      (order === 'desc') ? (comparison * -1) : comparison
    );

  };
}

export const sortLinks = (func_links, prop) => {
  prop = prop.split(".");
  const len = prop.length;

  func_links.sort((a, b) => {
    for (let i = 0; i < len; i += 1) {
      a = a[prop[i]];
      b = b[prop[i]];
    }

    if (a < b)
      return -1;
    else if (a > b)
      return 1;
    else
      return 0;
  });
  return func_links;
}

export const sortAndRemoveDuplicateStringValues = (array) => {
  var uniqueArray = [];
        
  for(let i=0; i < array.length; i++){
      if(uniqueArray.indexOf(array[i]) === -1) {
          uniqueArray.push(array[i]);
      }
  }

  uniqueArray = uniqueArray.sort();
  return uniqueArray;
}